import { getScreenType } from "@core/lib/ui/getScreenType";
import { useWire } from "@core/wire";
import { stAnalytics } from "@repo/analytics";
import { TbMessageCircle2 } from "solid-icons/tb";
import type { Component } from "solid-js";
import { isServer } from "solid-js/web";
import styles from "./FeedbackButton.module.css";
import { useFABClose } from "./FloatingActionButton";

export const FeedbackButton: Component = () => {
  const wire = useWire();
  const closeFAB = useFABClose();

  const handleClick = () => {
    if (isServer) return;

    stAnalytics.track("click_tracking", {
      cta: "feedback",
      position: "floating_action_button",
      screen: getScreenType(),
      value: "open_feedback_panel",
    });

    wire.services.feedback.openFeedbackPanel();
    closeFAB?.();
  };

  return (
    <button type="button" onClick={handleClick} class={styles.feedbackButton} aria-label="Send Feedback">
      <TbMessageCircle2 class={styles.icon} />
      <span class={styles.text}>Send Feedback</span>
    </button>
  );
};
